import { SourcesList } from 'ai-components-ui-library/components/informative/sources/SourcesList';
import unescapedText from 'I18n/utils/unescapedText';
import { groupBy } from '../../utils/groupBy';
import { isCallTranscriptCitation, isCrmDataCitation, isWebDataCitation } from './types';
import { useMemo } from 'react';
import { CitationSourceButton } from './CitationSourceButton';
import { ObjectTypeDefinitionsProvider } from '../ObjectTypeDefinitionsProvider/ObjectTypeDefinitionsProvider';
import { assertUnreachable } from '../../utils/assertUnreachable';
import { jsx as _jsx } from "react/jsx-runtime";
const getSourceGroup = source => {
  if (isCrmDataCitation(source) || isCallTranscriptCitation(source)) {
    return 'CRM_DATA';
  }
  if (isWebDataCitation(source)) {
    return 'WEB_DATA';
  }
  assertUnreachable(source);
  return 'CRM_DATA';
};
const getSourceGroupTitle = sourceGroup => {
  switch (sourceGroup) {
    case 'CRM_DATA':
      return unescapedText('citation.sourcesList.crmDataTitle');
    case 'WEB_DATA':
      return unescapedText('citation.sourcesList.webDataTitle');
    default:
      assertUnreachable(sourceGroup);
      return '';
  }
};
const getSourceKey = source => {
  if (isCrmDataCitation(source)) {
    return `${source.propertyName}-${source.objectId}-${source.objectTypeId}`;
  }
  if (isWebDataCitation(source)) {
    return `${source.url}-${source.domain}-${source.title}`;
  }
  if (isCallTranscriptCitation(source)) {
    return `${source.callId}-${source.transcriptId}`;
  }
  assertUnreachable(source);
  return '';
};
export const CitationSourcesList = ({
  sources
}) => {
  const sourcesByGroup = useMemo(() => groupBy(sources, getSourceGroup), [sources]);
  if (sources.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ObjectTypeDefinitionsProvider, {
    children: /*#__PURE__*/_jsx(SourcesList, {
      children: Object.keys(sourcesByGroup).map(sourceGroup => {
        const sourcesOfType = sourcesByGroup[sourceGroup];
        return /*#__PURE__*/_jsx(SourcesList.Section, {
          title: getSourceGroupTitle(sourceGroup),
          children: sourcesOfType.map(source => /*#__PURE__*/_jsx(CitationSourceButton, {
            source: source
          }, getSourceKey(source)))
        }, sourceGroup);
      })
    })
  });
};